module.exports = __webpack_public_path__ + "fonts/Lato-Black.dae5447e.woff";